import { render, staticRenderFns } from "./ConfrontLoadCheck.vue?vue&type=template&id=06f98818"
import script from "./ConfrontLoadCheck.vue?vue&type=script&lang=js"
export * from "./ConfrontLoadCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports